import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import {
  VehicleListItem,
  vehicleListQuery,
} from "@/app/Vehicles/GraphQL/vehicleListQuery";
import { Link } from "@/components/catalyst/link";
import { vehicleRecordQuery } from "@/app/Vehicles/GraphQL/vehicleRecordQuery";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { VehicleCreateDialog } from "@/app/Vehicles/Components/VehicleCreateDialog";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import { CreateVehicleInput } from "@/gql/graphql";
import { VehicleIcon } from "@/app/Vehicles/Components/VehicleIcon";

export function VehicleInput({
  initialFixtureValues,
  ...props
}: BaseComboboxInputProps<
  ResultOf<typeof vehicleListQuery>,
  VariablesOf<typeof vehicleListQuery>,
  VehicleListItem,
  ResultOf<typeof vehicleRecordQuery>
> & {
  initialFixtureValues?: Partial<CreateVehicleInput>;
}) {
  const { supplierId } = useGlobalSupplier();
  const { openAsPromise } = useDialog(VehicleCreateDialog);

  return (
    <ComboboxInput
      document={vehicleListQuery}
      accessor={(data) => data.vehicles.data}
      getQueryVariables={(search) => ({
        first: 20,
        page: 1,
        search,
      })}
      recordDocument={vehicleRecordQuery}
      recordAccessor={(data) => data.vehicle}
      getViewNode={(item) =>
        item ? (
          <Link
            className="flex text-blue-500"
            to="."
            search={(prev: any) => ({
              ...prev,
              vehicleId: item.id,
            })}
          >
            <VehicleIcon model={item} className="mr-2 size-5" />

            <span>{item.name}</span>
          </Link>
        ) : null
      }
      getKey={(i) => i.id}
      getListItemNode={(i) => (
        <div className="flex items-center space-x-2">
          <img
            className="size-6 object-contain"
            alt={i.name}
            src={i.heroImage}
          />
          <span>{i.name}</span>
        </div>
      )}
      getInputNode={(i) => (
        <div className="flex items-center space-x-2">
          <img
            className="size-6 object-contain"
            alt={i.name}
            src={i.heroImage}
          />
          <span>{i.name}</span>
        </div>
      )}
      fixture={(search) => {
        return {
          label: `Add ${search || "new"}`,
          onClick: () => {
            return openAsPromise({
              initialValues: {
                supplier: {
                  connect: supplierId ?? null!,
                },
                name: search,
                ...initialFixtureValues,
              },
            });
          },
        };
      }}
      {...props}
    />
  );
}
